// eslint-disable-next-line no-restricted-imports
import { useNavigate } from '@remix-run/react'
import { useCallback } from 'react'
import type { CalendarContext, CourseSelectContext, ReserveInputContext } from '~/navigation'
import { useBack, useReserveOverlay } from '~/navigation'
import { useHistoryStack } from '~/navigation/store'

export function useCloseCalendar() {
  const [context] = useReserveOverlay('CALENDAR')
  return useClose(context)
}

export function useCloseNewReserveInput() {
  const [context] = useReserveOverlay('COURSE_SELECT', 'NEW_RESERVE_INPUT', 'NEW_RESERVE_ERROR')
  return useClose(context)
}

export function useCloseNewReserveSuccess() {
  const [context] = useReserveOverlay('NEW_RESERVE_SUCCESS')
  return useClose(context)
}

function useClose(
  context: CourseSelectContext | ReserveInputContext | CalendarContext | undefined
) {
  const historyStack = useHistoryStack()
  const navigate = useNavigate()
  const back = useBack()
  const { restaurantId, visitorsCount, visitDate, visitTime } = context ?? {}

  return useCallback(() => {
    const target = (
      [
        'MENUS', // メニュー画面からプラン表示したときはワンステップ戻るだけでよい
        'LIST', // 予算絞り込みなどリストでプラン表示したとき
        'GUIDE', // ガイドのコース一覧からプラン表示したとき
      ] as const
    ).find((value) => {
      return historyStack.some((s) => s.value === value)
    })
    if (target) {
      back(target)
    } else {
      // 予約入力に直接ランディングしたときは、直接useNavigateを使って×ボタンをガイドへのリンクとする
      const params = new URLSearchParams()
      if (visitorsCount !== undefined && visitorsCount > 0) {
        params.set('visitorsCount', String(visitorsCount))
      }
      if (visitDate !== undefined) {
        params.set('visitDate', visitDate)
      }
      if (visitTime !== undefined) {
        params.set('visitTime', visitTime)
      }
      const qs = params.toString().length > 0 ? `?${params}` : ''
      navigate(`/${restaurantId}${qs}`)
    }
  }, [historyStack, navigate, back, restaurantId, visitorsCount, visitDate, visitTime])
}
